export default function TableCell(theme) {
  return {
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: `1px solid ${theme.palette.divider}`,
          padding: "4px 12px",
          fontSize: "12px"
        },
        sizeSmall: {
          padding: "6px 14px",
          fontSize: "15px"
        },
      },
    },
  };
}
